export default __webpack_public_path__ + "static/media/legend_shallow_groundwater.050e4ef7.png";